import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { MatStep, MatStepper } from '@angular/material/stepper';

@Component({
  selector: 'app-mobile-stepper',
  templateUrl: './mobile-stepper.component.html',
  styleUrls: ['./mobile-stepper.component.scss'],
})
export class MobileStepperComponent {
  @Input({ required: true }) stepper!: MatStepper;

  isOpen = false;
  panelTop = 0;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  get steps(): MatStep[] {
    return this.stepper?.steps?.toArray() ?? [];
  }

  get selectedIndex(): number {
    return this.stepper?.selectedIndex ?? 0;
  }

  get selectedStep(): MatStep | undefined {
    return this.steps[this.selectedIndex];
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.panelTop = Math.max(
      0,
      this.elementRef.nativeElement.getBoundingClientRect().top
    );
    this.isOpen = true;
  }

  @HostListener('document:keydown.escape')
  close() {
    this.isOpen = false;
  }

  isDone(step: MatStep, index: number): boolean {
    return step.completed && index !== this.selectedIndex;
  }

  // mirrors the mat-stepper rules so steps the stepper would refuse are shown as disabled
  canSelect(index: number): boolean {
    if (index === this.selectedIndex) return true;
    if (index < this.selectedIndex && !this.steps[index]?.editable)
      return false;
    if (!this.stepper.linear) return true;

    return this.steps
      .slice(0, index)
      .every((step) => step.completed || step.optional);
  }

  select(index: number) {
    if (!this.canSelect(index)) return;

    this.stepper.selectedIndex = index;
    this.close();
  }
}
